import {Directive, ElementRef, Input} from '@angular/core';
import {animate, AnimationBuilder, AnimationPlayer, style} from '@angular/animations';
const animations: any = {};
animations['slideLeft'] = [
  style({ transform: 'translateX(0%)' }),
  animate('.3s ease-out', style({ transform: 'translateX(108%)' })),
];
animations['slideRight'] = [
  style({ transform: 'translateX(108%)' }),
  animate('.3s ease-out', style({ transform: 'translateX(0%)' })),
];
animations['slideFirstStep'] = [
  style({ transform: 'translateX(-100%)' }),
  animate('.3s ease-out', style({ transform: 'translateX(0%)' })),
];
animations['slideSecondStep'] = [
  style({ transform: 'translateX(0%)' }),
  animate('.3s ease-out', style({ transform: 'translateX(-100%)' })),
];
animations['slideThirdStep'] = [
  style({ transform: 'translateX(-100%)' }),
  animate('.3s ease-out', style({ transform: 'translateX(-206%)' })),
];
@Directive({
  selector: '[tartAnimation]',
})
export class TartAnimationDirective {
  player: AnimationPlayer;

  constructor(private builder: AnimationBuilder,private element: ElementRef) {}

  @Input() set elementAnimation(animation: string){
    if(animation) {
      if(this.player) {
        this.player.destroy();
      }

      const metadata = animations[animation];
      const factory = this.builder.build(metadata);
      const player = factory.create(this.element.nativeElement);

      player.play();
    }
  };





}
